/**
 * Menu Type Definitions
 *
 * This file contains TypeScript interfaces and constants for menu routes and related data structures.
 */

/**
 * Menu type enumeration constant
 */
export const MenuTypeConst = {
  MAIN: "MAIN",
  ADMIN: "ADMIN",
  ALL: "ALL",
} as const;

/**
 * Menu type values - "MAIN" | "ADMIN" | "ALL"
 */
export type MenuType = typeof MenuTypeConst[keyof typeof MenuTypeConst];

/**
 * Represents a single menu route item
 */
export interface MenuRoute {
  to?: string;
  layout?: string;
  name?: React.ReactNode;
  view?: boolean;
  subPages?: string[];
  isForceAvailableMenu?: boolean;
  collapse?: boolean;
  state?: string;
  icon?: React.ReactNode;
  views?: MenuRoute[];
  isLabFeature?: boolean;
  topOverview?: boolean;
  /** When true, renders a "Sensolus only" badge next to this menu item. */
  systemOnly?: boolean;
  /**
   * Computed by the menu hook: the item does not apply at the currently
   * selected level (wiki Rule #5 — e.g. Diagnostic at cross-level "All",
   * Location settings with a partner org sliced; STIC-15615 R9/R11).
   * NavList greys it out but keeps it clickable; the page behind it should
   * render <NotAvailableAtThisLevel /> and explain.
   */
  disabled?: boolean;
}

/**
 * Default path object with pathname and search params
 */
export interface DefaultPath {
  pathname: string;
  search: string;
}

/**
 * Return type of useAvailibleMenu hook
 */
export interface AvailibleMenuData {
  routes?: MenuRoute[];
  availableMenuPaths: Record<string, MenuRoute>;
  forceMenuPaths?: Record<string, MenuRoute>;
  allPaths: Record<string, MenuRoute>;
  defaultPath: DefaultPath | string;
  isAdminMenuAvailable?: boolean;
}

/**
 * Default export for backwards compatibility with JavaScript files
 */
export default MenuTypeConst;
